import { createApi } from '@reduxjs/toolkit/query/react';

import { axiosBaseQuery } from './axiosBasedQuery';
import { HTTP_METHODS } from '../../utils/handler';
import { API_BASE_URL } from '../../config';

const { GET } = HTTP_METHODS;

// 🔹 API Routes
const GET_HRX_MODULE = '/hrx-module/get-hrx-module';

export const hrxModuleApi = createApi({
  reducerPath: 'hrxModuleApi',

  baseQuery: axiosBaseQuery({
    baseUrl: API_BASE_URL,
    credentials: true
  }),

  tagTypes: ['HrxModule'],

  endpoints: (builder) => ({
    // ✅ Get all HRX modules
    getHrxModuleList: builder.query({
      query: (params) => ({
        url: GET_HRX_MODULE,
        method: GET,
        params
      }),
      providesTags: ['HrxModule']
    })
  })
});

export const { useGetHrxModuleListQuery } = hrxModuleApi;
